import { gql, useLazyQuery, useQuery } from '@apollo/client';

export const mainDirectoryListQuery = gql`
    query MainDirectoryList($limit: Int, $skip: Int, $filter: [DirectoryListFilterInput!]!, $sort: [DirectoryListSortInput]) {
        allMainDirectoryList(filter: $filter, limit: $limit, skip: $skip, sort: $sort) {
            nodes {
                id
                dateCreated {
                    js
                }
                dateModified {
                    js
                }
                description
                caption
                favourite
                folder
                listType
                viewType @client
                parentID
                recordType
                securityUserID
                tableName
            }
        }
    }
`;

export interface IMainDirectoryListVariables {
    limit?: number;
    skip?: number;
    filter: IMainDirectoryListFilter[];
    sort?: {
        field: 'ID' | 'DESCRIPTION' | 'PARENT_ID';
        order: 'ASC' | 'DESC';
    }[];
}

export interface IMainDirectoryListItem {
    id: string;
    dateCreated?: {
        js: string;
    };
    dateModified?: {
        js: string;
    };
    description?: string;
    caption: string;
    favourite?: boolean;
    folder: boolean;
    listType: starrez.DirectoryListTypeEnum;
    viewType?: starrez.DirectoryViewType;
    parentID: number;
    recordType?: starrez.RecordType;
    securityUserID?: number;
    tableName?: string;
    __typename?: string;
}

export interface IMainDirectoryListQueryResults {
    allMainDirectoryList: {
        nodes: IMainDirectoryListItem[];
    };
}

export interface IMainDirectoryListFilter {
    listType?: { eq?: starrez.DirectoryListTypeEnum; in?: starrez.DirectoryListTypeEnum[] };
    folder?: { eq?: boolean };
    search?: { like?: string };
    parentID?: { eq?: number; ne?: number };
    favourite?: { eq?: boolean };
}

export const useMainDirectoryListQuery = (variables: IMainDirectoryListVariables) =>
    useQuery<IMainDirectoryListQueryResults, IMainDirectoryListVariables>(mainDirectoryListQuery, { variables });

export const useLazyMainDirectoryListQuery = (variables: IMainDirectoryListVariables) =>
    useLazyQuery<IMainDirectoryListQueryResults, IMainDirectoryListVariables>(mainDirectoryListQuery, { variables });
